import { deeplinkNavigation } from './DeeplinkNavigationParams'

export const navigateBudgetSetting = () => {
  deeplinkNavigation({
    name: 'BudgetSetting',
  })
}
